import { render, staticRenderFns } from "./AdminRoleDetail.vue?vue&type=template&id=33d5faa7&scoped=true"
import script from "./AdminRoleDetail.vue?vue&type=script&lang=ts"
export * from "./AdminRoleDetail.vue?vue&type=script&lang=ts"
import style0 from "./AdminRoleDetail.vue?vue&type=style&index=0&id=33d5faa7&lang=scss"
import style1 from "./AdminRoleDetail.vue?vue&type=style&index=1&id=33d5faa7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5faa7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d5faa7')) {
      api.createRecord('33d5faa7', component.options)
    } else {
      api.reload('33d5faa7', component.options)
    }
    module.hot.accept("./AdminRoleDetail.vue?vue&type=template&id=33d5faa7&scoped=true", function () {
      api.rerender('33d5faa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/admin-roles/components/AdminRoleDetail.vue"
export default component.exports